import styled from 'styled-components';

export const OTPInputContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 6px;
    margin-bottom: 27px;
`;

export const OTPInputBox = styled.input`
    width: 40px;
    height: 40px;
    border: 1px solid #a5a5a5;
    border-radius: 8px;
    padding: 0;
    text-align: center;
    line-height: 1;
    font-size: 16px;

    &:focus {
        border-color: #1874fd;
    }
`;
